import { postReq, putReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginationFilterRequest, PaginatedSelectModel } from "@/models/core.model";
import { ApproveScrapedEvent, ScrapedEvent, scrapedEventFromJson, ScrapedEventPaginationFilterRequest, UpdateScrapedEvent } from '@/models/scraped-event.model';

export const getPagedScrapedEvents = async (input: ScrapedEventPaginationFilterRequest): Promise<PagedResponseModel<ScrapedEvent>> => {
  return await getReq(createUrl("a/ScrapedEvent/PagedData"),
    { params: input }
  ).then((res: any) => ({
      ...res.data,
      result: res.data.result.map(itm => scrapedEventFromJson<ScrapedEvent>(itm))
    }));
};

export const getScrapedEventsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedScrapedEvents(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `${itm.name} (${itm.countryName})`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getScrapedEvent = async (id: number): Promise<BaseResponseModel<ScrapedEvent>> => {
  return await getReq(createUrl(`a/ScrapedEvent/GetById/${id}`),
  ).then((res: any) => ({
      ...res.data,
      result: scrapedEventFromJson<ScrapedEvent>(res.data.result)
    }));
};

export const approveScrapedEvent = async (input: ApproveScrapedEvent): Promise<BaseResponseModel<number>> => {
  return await postReq(createUrl("a/ScrapedEvent/Approve"), input)
  .then((res: any) => res.data);
};

export const updateScrapedEvent = async (input: UpdateScrapedEvent): Promise<BaseResponseModel<null>> => {
  return await putReq(createUrl("a/ScrapedEvent/Update"),
    input
  ).then((res: any) => res.data);
};
